// src/sections/AngabenZumDachSection.jsx
import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";
import { Box, Button } from "@chakra-ui/react";


export default function AngabenZumDachSection({ selectedAnlageId }) {
  const [checkedValues, setCheckedValues] = useState([]);
  const options = ["Satteldach", "Flachdach", "Pultdach", "Sheddach", "andere"];

  // ✅ LOAD existing data
  useEffect(() => {
  if (!selectedAnlageId) return;

  axios
    .get(`${process.env.REACT_APP_API_URL}/api/angabenzumdach/anlage/${selectedAnlageId}`)
    .then((res) => {
      const data = res.data;
      const loaded = [];

      if (data.satteldach) loaded.push("Satteldach");
      if (data.flachdach) loaded.push("Flachdach");
      if (data.pultdach) loaded.push("Pultdach");
      if (data.sheddach) loaded.push("Sheddach");
      if (data.andere) loaded.push("andere");

      setCheckedValues(loaded);
    })
    .catch(() => {
      setCheckedValues([]);
    });
}, [selectedAnlageId]);

  const handleSave = async () => {
   const checked = checkedValues;

    const payload = {
      anlage: { id: selectedAnlageId },
      satteldach: checked.includes("Satteldach"),
      flachdach: checked.includes("Flachdach"),
      pultdach: checked.includes("Pultdach"),
      sheddach: checked.includes("Sheddach"),
      andere: checked.includes("andere"),
    };

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/angabenzumdach/anlage/${selectedAnlageId}`
      );

      // update
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/angabenzumdach/${res.data.id}`,
        payload
      );
      showSuccess("Gespeichert", "Angaben zum Dach wurden aktualisiert");
    } catch {
      // create
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/angabenzumdach`,
        payload
      );
        showSuccess("Gespeichert", "Angaben zum Dach wurden gespeichert");
    }
  };

  return (
        <Box 
          p={8} 
          bg="white" 
          borderRadius="xl" 
          boxShadow="md" 
          mt={6} 
          mb={10} 
          maxW="fit-content"
        >
      <h3
        style={{
          marginBottom: 16,
          color: "#000000",
          fontWeight: "700",
          textTransform: "uppercase",
          marginLeft: 0,
          fontSize: "24px"
        }}
      >
        ANGABEN ZUM DACH
      </h3>

      <div
        style={{
          background: "#f7fafc",
          padding: 16,
          borderRadius: 8,
          display: "grid",
          gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
          gap: 12,
        }}
      >
        {options.map((opt) => (
          <label
            key={opt}
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
           <input
  type="checkbox"
  value={opt}
  checked={checkedValues.includes(opt)}
  onChange={(e) =>
    setCheckedValues((prev) =>
      e.target.checked
        ? [...prev, opt]
        : prev.filter((v) => v !== opt)
    )
  }
/>
            <span>{opt}</span>
          </label>
        ))}
      </div>

      <Button
        type="button"
        bg="#B8860B"
         _hover={{ bg: "#C99414" }}
        size="lg"
        width="fit-content" 
        onClick={handleSave}
      >
        Speichern Angaben zum Dach
      </Button>
     </Box>
  );
}